import { diffWords, type Change } from 'diff';

export type DiffPart = Change;

/** Word-level diff, used to highlight additions/removals within a section's prose. */
export function diffText(oldText: string, newText: string): DiffPart[] {
  return diffWords(oldText ?? '', newText ?? '');
}

export function hasChanges(parts: DiffPart[]): boolean {
  return parts.some((part) => part.added || part.removed);
}
